import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../../tableSettings";
import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import AbstractListView, {
DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer
} from "../../../common/AbstractListView";
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  CurrencyAmountRenderer, DateRenderer, DateTimeRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import useReportViewer from '../../../../hooks/useReportViewer';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../../uiControls/CurrencyLabel';
import {JobNames} from "../../../../framework.core/JobNames";
import { DocumentType } from "../../../../framework.core/DocumentType";
import {agentPaymentList} from "../../tableSettings";
import {AgentPaymentListItem} from "../../../../fms.data/models/AgentPaymentListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import HistoryViewPayment from '../../../reports/HistoryViewPayment';
import IfmsModal from '../../../../ui/IfmsModal';
import { FmsSubMenu } from '../../../../constants/fmsSubMenu';
import { FmsSecTask } from '../../../../fms.core/constants';
import { CheckSubArgs } from '../../../../fms.report/args';
import { findSecurityTask, getSecBySecTask } from '../../../../util';
import { useJournal } from '../../general/journal/JournalListView';
import { formatDate, nowDate } from '../../../../dateUtils';
import AgentBalanceDetails from '../../../reports/AccountBalance';
import { SecType } from '../../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../../common/commonExportFormat';
import IconButton, { AddIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, ViewHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';
import DepositIcon from '../../../../img/Print Deposit Slip.svg';
import DepositIcon_D from '../../../../img/Print Deposit Slip_Dark.svg';
import { SearchModelBase } from '../../../../fms.data/models/SearchModelBase';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function VoidDateRenderer({cell, row}:any) {
  return (
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default ifms-table-date data-row-fontred">
      {formatDate(cell.value)}
    </div>
  );
}

function TypeRenderer({ cell ,data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lPayment = (l as any).payment as string;
  if (lPayment === 'C') dataTooltip = 'CHECK';
  else if( lPayment === 'W') dataTooltip = 'W/T';
  else if( lPayment === 'O') dataTooltip = 'OTHER';
  else if (lPayment === 'OF') dataTooltip = 'OFFSET';

  return (
    <div  className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ textAlign: 'center'}}>{cell.value}</div>
  );
}

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    
  </div>;
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  function OpenNewPageAsync(link:string) {
    openNewPage(history, link, NavigationType.newPage);
    return Promise.resolve(true);
  }

  async function create() {
    // if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acAgentPayment/add')) {
    //   await showGlobalOkDialog(<p>New operation is already in progress</p>);
    //   return;
    // }
    if (selectedElement?.agentId > 0) {
      openNewPage(history, `/accounting/acAgentPayment/add/${selectedElement.agentId}`, NavigationType.newPage);
    } else {
      openNewPage(history, `/accounting/acAgentPayment/add`, NavigationType.newPage);
    }
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Agent Settlement first', false, null, "warning");
      return;
    }

    if (!selectedElement.isDraft) {
      await showGlobalOkDialog('Can delete the Draft Payment', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AgntPayment, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message);
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =  `/accounting/acAgentPayment/edit/${id}`;
    const viewUrl = `/accounting/acAgentPayment/view/${id}`;
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/accounting/acAgentPayment/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =  `/accounting/acAgentPayment/edit/${id}`;
    const viewUrl = `/accounting/acAgentPayment/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    // if (jobListContext.hasOpenedScreenStartingWithUrl('/accounting/acAgentPayment/add')) {
    //   await showGlobalOkDialog(<p>New operation is already in progress</p>);
    //   return;
    // }

    const id = selectedElement.id;
    openNewPage(history, `/accounting/acAgentPayment/add?copyId=${id}`, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctAPayDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AgntPayment}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }


  async function switchToBillings(){
    if (!selectedElement) {
      return;
    }

    let isExistId = false;

    const apiResult = await appContext.api.getRelatedBillingIds(selectedElement.id);
    if(apiResult && apiResult.result){
      const billingids = apiResult.result;     
      let model = new SearchModelBase();

      if(billingids.RelateCrDbId && billingids.RelateCrDbId.length > 0){ 
        isExistId = true;
        model.extraWhere = `Id in (${billingids.RelateCrDbId})`;
        jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/accounting?parentOp=billings',
        '','','Billings','',false,true,model);
        await OpenNewPageAsync('/common/joblistview/crdb/accounting?parentOp=billings');
      }
    } 
    if(!isExistId){
      await showGlobalOkDialog("Can not go to Billings List.");
    }
  }      
  

  return {create, deleteItem: deleteItem, edit, view, copy, moveToDeleteHistoryReport, switchToBillings};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, switchToBillings } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);

  const appContext = useContext(ApplicationContext);
  
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
  const crdbSec = findSecurityTask(appContext, FmsSecTask.AcctCrDbList);
  const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;

  const items = [
    // { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd  },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to Billings List', shortcut:'F6', separator: false, disabled : !crdbSec?.grantRead },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="agentPayment-list-sub-menu"  width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      // case 0:
      //   create();
      //   break;
      case 0:
        view();
        break;
      case 1:
        edit();
        break;
      case 2:
        // deleteItem();
        view();
        break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      case 4:
        switchToBillings();
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;
  // const {switchJournal} = useJournal();
  // const appContext = useContext(ApplicationContext);
  
  // if (!getSecBySecTask(appContext, FmsSecTask.ListJournalPayment, SecType.Read) && !userId.startsWith('@')) {
  //   return null;
  // }
  
  // return (
  //   <JournalIconButton onClick={()=> switchJournal(JobNames.AgntPayment, selectedElement.id, "", null, selectedElement.checkNo)} useText/>
  // );
  return null;
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as AgentPaymentListItem;

  const {create, deleteItem, edit, view, moveToDeleteHistoryReport, /*copy*/} = useSelectedOperations();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const {switchJournal} = useJournal();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/acAgentPayment/view/${id}`);
  }
  
  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print() {
    if (!selectedElement) {
      return;
    }

    const title = `Deposit Slip [${selectedElement?.checkNo}]`;
    const args = new CheckSubArgs({
      docType: DocumentType.CheckSub,
      formCaption: title,
      subject: title,

      tbId: selectedElement?.id.toString() ?? '',
      tbName: "T_DEPOHD"
    });

    viewReport(args, "", true);
  }

  async function agentBalance() {
    if (selectedElement.agentId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Agent.</p>, false, null, 'warning');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <AgentBalanceDetails
          jobId={selectedElement.id}
          jobName={JobNames.AgntPayment}
          onPopupClose={onPopupClose}
          toDate={selectedElement.postDate??nowDate()}
          comId={selectedElement.agentId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.firstAgent}
        />
    })
  }

  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
  const readSecDelHistory = getSecBySecTask(appContext, FmsSecTask.AcctAPayDeleteHistory, SecType.Read);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalPayment, SecType.Read) && !userId.startsWith('@');

  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      {/* <AddIconButton name='agentPayment-list-add-button' disabled={!canBeAdd} onClick={create} useText iconMode={true} /> */}
      <div className='ifms-common-vertical-gap-8'>
        <EditIconButton2 name='agentPayment-list-edit-button' disabled={!canBeEdit} onClick={edit} useText />
        <ViewIconButton2 name='agentPayment-list-view-button' disabled={!hasSelectedRow} onClick={view} useText  />
        <DeleteIconButton2 name='agentPayment-list-delete-button' disabled={!canBeDeleted} onClick={view} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <ViewHistoryIconButton name='agentPayment-list-history-button' disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1240, popupComponent: <HistoryViewPayment jobId={selectedElement.id} jobType={FmsSubMenu.APHistory} /> })} useText/>
        <DeleteHistoryIconButton name='agentPayment-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} disabled={false} useText />
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      {/* <IconButton data-tooltip='Print Deposit Slip' name='agentPayment-list-print-button' disabled={!hasSelectedRow} onClick={print} icon={appContext.useDarkMode ? DepositIcon_D : DepositIcon} useText /> */}
      {!checkSecJournal &&  <JournalIconButton onClick={()=> switchJournal(JobNames.AgntPayment, selectedElement.id, "", null, selectedElement.checkNo)} useText/> }
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAgntPayment);
  const crdbSec = findSecurityTask(appContext, FmsSecTask.AcctCrDbList);
  const history = useHistory();

  const {create, edit, view, switchToBillings} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F2") {
      // if(listSec?.grantAdd)
      //   create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F6"){
      if(crdbSec?.grantRead)
        switchToBillings();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F2', 'F3', 'F9', 'F11', 'F8', 'F6'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }
  

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.AgntPayment}
      //entityId={(jobListContext.selectedElement as AgentPaymentListItem | null)?.id}
      jobId={(jobListContext.selectedElement as AgentPaymentListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Agent Payment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AgntPayment,
      'AgentPaymentListItem',
      AgentPaymentListItem.calculateSearchParameters(search, AgentPaymentListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: AgentPaymentListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AgntPayment, 'AgentPaymentListItem',
      AgentPaymentListItem.calculateSearchParameters(search, AgentPaymentListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  AgentPaymentListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      {accessor: 'isDraft', Cell: NullableCheckboxIconRenderer},
      {accessor: 'block', Cell: NullableCheckboxIconRenderer},
      {accessor: 'void', Cell: NullableCheckboxIconRenderer, Header: () => <div data-tooltip="Void">V</div>},
      {accessor: 'customer', Cell: TextAlignLeftRenderer},
      {accessor: 'receivedFrom', Cell: TextAlignLeftRenderer},
      {accessor: 'payment', Cell: TypeRenderer},
      {accessor: 'checkNo', Cell: TextAlignLeftRenderer},
      {accessor: 'bank', Cell: TextAlignLeftRenderer},
      {accessor: 'currency', Cell: TextRenderer},
      {accessor: 'amount', Cell: (props:any) => <CurrencyAmountRenderer currencyAccessor={(x:any) => x.currency} {...props} />},
      {accessor: 'chkPrint', Cell: TextRenderer},
      {accessor: 'invoiceNo', Cell: TextAlignLeftRenderer},
      {accessor: 'invBillCrdb', Cell: TextAlignLeftRenderer},
      {accessor: 'remark', Cell: TextAlignLeftRenderer},
      {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
      {accessor: 'u2ID', Cell: TextAlignLeftRenderer},

      {accessor: 'postDate', Cell: DateRenderer},
      {accessor: 'depositDate', Cell: DateRenderer},
      {accessor: 'voidDate', Cell: VoidDateRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u1Date', Cell: DateTimeRenderer},
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'isDraft', changedValue: (value: any) => { return nullableCheckBoxValue(value['isDraft'])} });
    colRenderer.push({ accessor: 'block', changedValue: (value: any) => { return nullableCheckBoxValue(value['block'])} });
    colRenderer.push({ accessor: 'void', changedValue: (value: any) => { return nullableCheckBoxValue(value['void'])} });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'voidDate', changedValue: (value: any) => { return formatDate(value['voidDate']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  agentPaymentList;
    const cols = AgentPaymentListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: AgentPaymentListItem) {
    return row && row.id ? `/accounting/acAgentPayment/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Agent Settlement List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AgntPayment} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
